import { render } from "./FaqRight.vue?vue&type=template&id=f50f0ca8"
import script from "./FaqRight.vue?vue&type=script&lang=js"
export * from "./FaqRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__